import { IOrderData } from '../../types/accounting/data/IOrderData';
import { ePartyPurpose } from '../../ui-toolkit/enums/ePartyPurpose';
import { FullNamePartyData } from '../../ui-toolkit/orders/interfaces/IParty';

export const showBorrowerNames = (order: Pick<IOrderData, 'parties'>) => {
  return order.parties
    .filter((t) => t.purpose === ePartyPurpose.borrower)
    .sort((a, b) => (a.partySequence || 0) - (b.partySequence || 0))
    .map((t) => FullNamePartyData(t))
    .join(', ');
};
